export default {
    'add-new-vacation': 'Add new vacation',
    'recurring-leave': 'Recurring leave',
    'one-time-leave': 'One-time leave',
    'add-vacation': 'Add vacation',
    'edit-vacation': 'Edit vacation',
    'is-constant': 'Is constant',
    'this-vacation': 'this vacation'
}